import { log } from '@guardian/libs';
import { bids } from './bidders/config';
export class PrebidAdUnit {
    code;
    bids;
    mediaTypes;
    gpid;
    ortb2Imp;
    constructor(advert, slot, pageTargeting, consentState) {
        this.code = advert.id;
        this.mediaTypes = { banner: { sizes: slot.sizes } };
        this.gpid = advert.gpid ?? '';
        this.ortb2Imp = {
            ext: {
                gpid: this.gpid,
                data: {
                    pbadslot: this.gpid,
                },
            },
        };
        this.bids = bids(advert.id, slot.sizes, pageTargeting, this.gpid, consentState);
        advert.headerBiddingSizes = slot.sizes;
        log('commercial', `PrebidAdUnit ${this.code}`, this.bids);
    }
    isEmpty() {
        return this.code == null;
    }
}
